export default __webpack_public_path__ + "static/media/Andorra2014.4e0100ee.jpg";